import { bankRoutes } from "./banks";
import { Route } from "../RouteModel";

export const administrationRoutes: Route = {
  i18nName: "Administration",
  showChildrenInSidebar: true,
  icon: undefined,
  path: "/administration",
  can: {
    do: "update",
    on: "bank",
  },
  children: [bankRoutes],
};
